export const GET_APPSETTINGS = "GET_APPSETTINGS";
export const SET_APPSETTING = "SET_APPSETTING";
